type TaxonomyFilterRemovalReason =
  | 'version_mismatch'
  | 'invalid_value'
  | 'missing_value'
  | 'legacy_format'
  | 'unknown_taxonomy';

export type TaxonomyFilterRemoval = {
  reason: TaxonomyFilterRemovalReason;
  savedVersion?: string;
  currentVersion?: string;
};

const readVersion = (value: unknown): string | undefined => {
  if (typeof value !== 'object' || value === null || !('version' in value)) {
    return undefined;
  }
  return typeof value.version === 'string' ? value.version : undefined;
};

/** Why a persisted taxonomy selection the caller already rejected was rejected. */
export const describeTaxonomyRejection = ({
  value,
  isValidValue,
  currentVersion,
}: {
  value: unknown;
  isValidValue: boolean;
  currentVersion?: string;
}): TaxonomyFilterRemoval => {
  if (!value) return { reason: 'missing_value', currentVersion };
  if (!isValidValue) return { reason: 'invalid_value', currentVersion };
  return {
    reason: 'version_mismatch',
    savedVersion: readVersion(value),
    currentVersion,
  };
};
